import React, { useState } from 'react';
import PanoramaViewer from './PanoramaViewer';

const ROOM_EMOJIS = { sala: '🛋️', cuarto: '🛏️', baño: '🚿', cocina: '🍳' };

const TourViewer = ({ tour }) => {
    const [activeRoomIndex, setActiveRoomIndex] = useState(0);

    if (!tour || tour.rooms.length === 0) {
        return (
            <div className="flex items-center justify-center h-64 text-gray-500">
                No hay cuartos en este tour.
            </div>
        );
    }

    const activeRoom = tour.rooms[activeRoomIndex];
    const hotspots = tour.rooms
        .filter((_, i) => i !== activeRoomIndex)
        .map(r => ({
            label: `${ROOM_EMOJIS[r.room_type] || '🏠'} Ir a ${r.name}`,
            onClick: () => setActiveRoomIndex(tour.rooms.indexOf(r)),
        }));

    return (
        <div className="space-y-4">
            <PanoramaViewer
                key={activeRoom.id}
                panoramaUrl={activeRoom.panorama_url}
                hotspots={hotspots}
                containerId={`panorama-${activeRoom.id}`}
            />
            <div className="flex items-center gap-2 flex-wrap">
                <span className="text-gray-500 text-sm">Cuartos:</span>
                {tour.rooms.map((room, i) => (
                    <button
                        key={room.id}
                        onClick={() => setActiveRoomIndex(i)}
                        className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
                            i === activeRoomIndex
                                ? 'bg-indigo-600 text-white'
                                : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
                        }`}
                    >
                        {ROOM_EMOJIS[room.room_type] || '🏠'} {room.name}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TourViewer;
